// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".header-button-menu-account[data-v-7aba3ba8]{list-style:none;min-width:200px}.header-button-menu-account a[data-v-7aba3ba8]{color:#000;display:block;padding:var(--spacing-sm-3) var(--spacing-md-2);-webkit-text-decoration:none;text-decoration:none;white-space:nowrap}.header-button-menu-account a[data-v-7aba3ba8]:hover{background:var(--color-lines-1)}.header-button-menu-account a[data-v-7aba3ba8]:last-child{border-top:1px solid #000}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
